import { render, staticRenderFns } from "./ReachToLimitModal.vue?vue&type=template&id=38d2decc&"
import script from "./ReachToLimitModal.vue?vue&type=script&lang=js&"
export * from "./ReachToLimitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports